import { render, staticRenderFns } from "./ProductsSearch.vue?vue&type=template&id=095b3371&scoped=true&"
import script from "./ProductsSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSearch.vue?vue&type=style&index=0&id=095b3371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b3371",
  null
  
)

export default component.exports